const oidc = {
    logout_success: 'خروج از حساب با موفقیت انجام شد.',
};
export default Object.freeze(oidc);
